"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.callAPI = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var callAPI = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var method, targetUrl, token, body, organisationId, teamId, headers, response, errorResponse, error, json;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            method = _ref.method, targetUrl = _ref.targetUrl, token = _ref.token, body = _ref.body, organisationId = _ref.organisationId, teamId = _ref.teamId;
            headers = token ? new Headers({
              'Cache-Control': 'no-cache',
              'Content-Type': 'application/json',
              token: token,
              'context-organisation': organisationId || '0',
              'context-team': teamId || '0'
            }) : new Headers({
              'Cache-Control': 'no-cache',
              'Content-Type': 'application/json'
            });
            _context.next = 4;
            return fetch(targetUrl, {
              method: method,
              headers: headers,
              body: JSON.stringify(body)
            });

          case 4:
            response = _context.sent;

            if (response.ok) {
              _context.next = 12;
              break;
            }

            _context.next = 8;
            return response.json();

          case 8:
            errorResponse = _context.sent;
            error = Error('Invalid API Response');
            error.msg = errorResponse.errors ? errorResponse.errors[0].message : errorResponse.statusMessage ? errorResponse.statusMessage : 'API Error';
            throw error;

          case 12:
            _context.next = 14;
            return response.json();

          case 14:
            json = _context.sent;
            return _context.abrupt("return", json);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function callAPI(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.callAPI = callAPI;